import { useState } from 'react';
import type { Job, Me } from '../api';
import { AuditTab } from '../components/AuditTab';
import { FlagsTab } from '../components/FlagsTab';
import { JOB_TYPE_LABELS } from '../components/JobDetail';
import { JobsTab } from '../components/JobsTab';
import { PluginsTab } from '../components/PluginsTab';
import { SkillsTab } from '../components/SkillsTab';
import { TabPanel, Tabs } from '../components/Tabs';
import { UsersTab } from '../components/UsersTab';
import { navigate, useLocation } from '../router';

export type AdminTab = 'users' | 'jobs' | 'plugins' | 'skills' | 'flags' | 'audit';
const TABS: { id: AdminTab; label: string }[] = [
  { id: 'users', label: 'Utilisateurs & instances' },
  { id: 'jobs', label: 'Tâches' },
  { id: 'plugins', label: 'Plugins' },
  { id: 'skills', label: 'Skills' },
  { id: 'flags', label: 'Flags' },
  { id: 'audit', label: 'Audit' },
];

/** L'onglet courant est dans l'URL (`/admin?tab=plugins`) : un retour depuis une page d'instance le retrouve. */
export function Admin({ me }: { me: Me }) {
  const { search } = useLocation();
  const requested = search.get('tab');
  const tab: AdminTab = TABS.find((t) => t.id === requested)?.id ?? 'users';
  const [focusJob, setFocusJob] = useState<string | null>(null);
  const [notice, setNotice] = useState<{ text: string; jobId: string } | null>(null);

  const select = (id: AdminTab) => navigate(id === 'users' ? '/admin' : `/admin?tab=${id}`);

  function onJob(job: Job) {
    setNotice({ text: `${JOB_TYPE_LABELS[job.type]} lancé pour ${job.username}.`, jobId: job.id });
  }

  return (
    <div className="stack">
      <h1>Console d'administration</h1>
      <Tabs label="Sections d'administration" tabs={TABS} active={tab} onChange={select} />
      <TabPanel id={tab}>
        {tab === 'users' && (
          <UsersTab
            me={me}
            onJob={onJob}
            notice={notice}
            onShowJobs={(id) => {
              setFocusJob(id);
              select('jobs');
            }}
          />
        )}
        {tab === 'jobs' && <JobsTab focusJobId={focusJob} />}
        {tab === 'plugins' && <PluginsTab />}
        {tab === 'skills' && <SkillsTab />}
        {tab === 'flags' && <FlagsTab />}
        {tab === 'audit' && <AuditTab />}
      </TabPanel>
    </div>
  );
}
